import { isShareContentType as isShareKind, SHARE_CONTENT_TYPES } from "@healthos/shared";
import { z } from "zod";
export { SHARE_CONTENT_TYPES };
export const ShareContentType = z.enum(SHARE_CONTENT_TYPES);
export function isShareContentType(value) {
    return isShareKind(value);
}
// Share Content: a member shares a recipe, article, guide, podcast, or
// similar CMS item with one or more teammates in their company, or posts
// it to the community wall.
//
// Two modes:
// - "direct": fan out one notification per recipient with a deep-link to
//   the content. Uses `recipientUserIds` (min 1, max 10).
// - "wall": post a `shared_content` moment to the community feed, visible
//   to the whole company. Uses `note` as the member's framing of why they
//   are sharing; falls back to the content title when no note is set. No
//   recipients needed.
//
// The payload mirror is what the recipient sees inline in the notification;
// the canonical content lives in the CMS.
export const ShareContentRequest = z
    .object({
    cmsUuid: z.string().min(1),
    contentType: ShareContentType,
    title: z.string().min(1),
    summary: z.string().max(1000).nullable().optional(),
    imageUrl: z.string().max(2048).nullable().optional(),
    byline: z.string().max(200).nullable().optional(),
    estimatedReadSeconds: z.number().int().positive().nullable().optional(),
    /** Durable player source for a Reset or Guide shared to the community wall. */
    videoUrl: z.string().max(2048).nullable().optional(),
    /** Durable player source for a podcast episode shared to the community wall. */
    audioUrl: z.string().max(2048).nullable().optional(),
    durationSeconds: z.number().int().positive().nullable().optional(),
    podcastTitle: z.string().max(200).nullable().optional(),
    // "direct" sends per-recipient notifications; "wall" posts a
    // `shared_content` moment to the community feed. Optional for backward
    // compatibility: a request without `mode` is treated as "direct" by the
    // notifier (`body.mode ?? "direct"`).
    mode: z.enum(["direct", "wall"]).optional(),
    recipientUserIds: z.array(z.string().uuid()).max(10).optional(),
    note: z.string().max(1000).optional(),
})
    .refine((data) => data.mode === "wall" || (data.recipientUserIds && data.recipientUserIds.length > 0), { message: "recipientUserIds is required when mode is direct" });
export const ShareContentResponse = z.object({
    shared: z.boolean(),
});
//# sourceMappingURL=share-content.js.map